import styled, { css } from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: ${({ $small }) => ($small ? '450px' : '700px')};
  z-index: 1;

  button {
    width: 100%;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;

    padding: ${({ $small }) => ($small ? '10px' : '16px')} 32px;
    background: ${({ theme }) => theme.colors.gradient.fullX};
    background-color: transparent;
    border-radius: 40px;
    border: none;
    color: ${({ theme }) => theme.colors.grey.white};

    &:hover {
      transition: 0.7s;
      opacity: 0.85;
    }
  }

  p,
  span {
    margin-bottom: -2px;
    opacity: 0.7;
  }

  div {
    width: ${({ $small }) => ($small ? '28px' : '36px')};
    height: ${({ $small }) => ($small ? '28px' : '36px')};
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 1.5%;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 20px;
    background-color: rgba(256, 256, 256, 0.3);
    border: 0;

    svg {
      opacity: 0.7;
      width: ${({ $small }) => ($small ? '18px' : '22px')};
      margin-left: -1px;
      color: ${({ theme }) => theme.colors.grey.white};

      path {
        stroke-width: 2.5px;
      }
    }
  }

  ${({ $mobile }) =>
    $mobile &&
    css`
      display: none !important;
      width: 100% !important;
      max-width: 100%;

      button {
        border-radius: 0;
        padding: 16px 10px !important;
      }
    `}

  @media ${({ theme }) => theme.devices.tablet} {
    margin: 0 4px;
    width: ${({ $small }) => ($small ? '50%' : '100%')};

    button {
      padding: 12px 16px;
    }
  }

  @media ${({ theme }) => theme.devices.mobile} {
    margin: 0;
    margin-top: 8px;
    display: ${({ $small }) => $small && 'none'};
    display: ${({ $mobile }) => $mobile && 'flex'} !important;

    span,
    p {
      font-size: 14px;
    }

    div {
      width: 28px;
      height: 28px;

      svg {
        width: 16px;
        height: 16px;
      }
    }
  }
`;
